import { fabric } from "fabric";
export const eraserBrush = (canvasRef) => {
  const penWidth = canvasRef.current.freeDrawingBrush.width;
  canvasRef.current.freeDrawingBrush = new fabric.EraserBrush(
    canvasRef.current
  );
  canvasRef.current.freeDrawingBrush.width = penWidth;
};
